(function (angular) {
    'use strict';

    angular
        .module("repairforms.service.module")
        .service("ConvertStringService", ConvertStringService);

    ConvertStringService.$inject = [];

    function ConvertStringService() {

        return {
            convertToUpperCase : convertToUpperCase,
            convertStringToNumber : convertStringToNumber
        }

        function convertToUpperCase(name){
            return angular.element("[name=" + name + "]").val().toUpperCase();
        }

        function convertStringToNumber(name){
            if(angular.element("[name=" + name + "]").val()) {
                return Number(angular.element("[name=" + name + "]").val());
            }
        };

    }

})(angular);